<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Edit Pickup Time</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <odd-label>Pickup Time</odd-label>
        <datetime v-model="pickupDatetime" type="datetime"></datetime>
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="updateOrderPickupDatetime"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  data() {
    return {
      pickupDatetime: "",
      loading: false,
      saving: false,
    };
  },
  props: {
    pk: {
      type: String,
      default: null
    }
  },
  components: {
    Datetime
  },
  computed: {
    showModal() {
      return this.pk !== null;
    }
  },
  watch: {
    showModal() {
      this.resetForm();
    },
    pk(newValue) {
      this.confirmValue = "";
      if (newValue !== null) {
        this.loading = true;
        this.$store.dispatch("orders/get", newValue).then(order => {
          this.pickupDatetime = order.pickup;
          this.loading = false;
        });
      }
    }
  },
  methods: {
    resetForm() {
      this.pickupDatetime = "";
      this.saving = false;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    updateOrderPickupDatetime() {
      this.saving = true;
      const order = {
        key: this.pk,
        pickup: this.pickupDatetime
      }
      this.$store.dispatch("orders/update", order).then(updatedOrder => {
        this.saving = false;
        this.$emit("close", true);
      });

    }
  }
};
</script>

<style>
.vdatetime-fade-enter-active,
.vdatetime-fade-leave-active {
  transition: opacity 0.4s;
}
.vdatetime-fade-enter,
.vdatetime-fade-leave-to {
  opacity: 0;
}
.vdatetime-overlay {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.5s;
}
.vdatetime-popup {
  box-sizing: border-box;
  z-index: 1000;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 340px;
  max-width: calc(100% - 30px);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  color: #444;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  line-height: 1.18;
  background: #fff;
  -webkit-tap-highlight-color: transparent;
}
.vdatetime-popup * {
  box-sizing: border-box;
}
.vdatetime-popup__header {
  padding: 18px 30px;
  background: #3f51b5;
  color: #fff;
  font-size: 32px;
}
.vdatetime-popup__title {
  margin-bottom: 8px;
  font-size: 21px;
  font-weight: 300;
}
.vdatetime-popup__year {
  font-weight: 300;
  font-size: 14px;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity 0.3s;
}
.vdatetime-popup__year:hover {
  opacity: 1;
}
.vdatetime-popup__date {
  line-height: 1;
  cursor: pointer;
}
.vdatetime-popup__actions {
  padding: 0 20px 10px 30px;
  text-align: right;
}
.vdatetime-popup__actions__button {
  display: inline-block;
  border: none;
  padding: 10px 20px;
  background: 0 0;
  font-size: 16px;
  color: #3f51b5;
  cursor: pointer;
  transition: color 0.3s;
}
.vdatetime-popup__actions__button:hover {
  color: #444;
}
.vdatetime-calendar__navigation--next:hover svg path,
.vdatetime-calendar__navigation--previous:hover svg path {
  stroke: #888;
}
.vdatetime-calendar__navigation,
.vdatetime-calendar__navigation * {
  box-sizing: border-box;
}
.vdatetime-calendar__navigation {
  position: relative;
  margin: 15px 0;
  padding: 0 30px;
  width: 100%;
}
.vdatetime-calendar__navigation--next,
.vdatetime-calendar__navigation--previous {
  position: absolute;
  top: 0;
  padding: 0 5px;
  width: 18px;
  cursor: pointer;
}
.vdatetime-calendar__navigation--next svg,
.vdatetime-calendar__navigation--previous svg {
  width: 8px;
  height: 13px;
}
.vdatetime-calendar__navigation--next svg path,
.vdatetime-calendar__navigation--previous svg path {
  transition: stroke 0.3s;
}
.vdatetime-calendar__navigation--previous {
  left: 25px;
}
.vdatetime-calendar__navigation--next {
  right: 25px;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.vdatetime-calendar__current--month {
  text-align: center;
  text-transform: capitalize;
}
.vdatetime-calendar__month {
  padding: 0 20px;
  transition: height 0.2s;
}
.vdatetime-calendar__month__day,
.vdatetime-calendar__month__weekday {
  display: inline-block;
  width: 14.28571%;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
}
.vdatetime-calendar__month__day > span,
.vdatetime-calendar__month__weekday > span {
  display: block;
  width: 100%;
  position: relative;
  height: 0;
  padding: 0 0 100%;
  overflow: hidden;
}
.vdatetime-calendar__month__day > span > span,
.vdatetime-calendar__month__weekday > span > span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  border-radius: 50%;
  transition: background-color 0.3s, color 0.3s;
}
.vdatetime-calendar__month__weekday {
  font-weight: 700;
}
.vdatetime-calendar__month__day:hover > span > span {
  background: #eee;
}
.vdatetime-calendar__month__day--selected:hover > span > span,
.vdatetime-calendar__month__day--selected > span > span {
  color: #fff;
  background: #3f51b5;
}
.vdatetime-calendar__month__day--disabled {
  opacity: 0.4;
  cursor: default;
}
.vdatetime-calendar__month__day--disabled:hover > span > span {
  color: inherit;
  background: 0 0;
}
.vdatetime-time-picker__list::-webkit-scrollbar-thumb {
  background: #ccc;
}
.vdatetime-time-picker__list::-webkit-scrollbar-track {
  background: #efefef;
}
.vdatetime-time-picker * {
  box-sizing: border-box;
}
.vdatetime-time-picker {
  box-sizing: border-box;
}
.vdatetime-time-picker::after {
  content: "";
  display: table;
  clear: both;
}
.vdatetime-time-picker__list {
  float: left;
  width: 50%;
  height: 305px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.vdatetime-time-picker__list::-webkit-scrollbar {
  width: 3px;
}
.vdatetime-time-picker__with-suffix .vdatetime-time-picker__list {
  width: 33.3%;
}
.vdatetime-time-picker__item {
  padding: 10px 0;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  transition: font-size 0.3s;
}
.vdatetime-time-picker__item:hover {
  font-size: 32px;
}
.vdatetime-time-picker__item--selected {
  color: #3f51b5;
  font-size: 32px;
}
.vdatetime-time-picker__item--disabled {
  opacity: 0.4;
  cursor: default;
  font-size: 20px !important;
}
.vdatetime-year-picker__list::-webkit-scrollbar-thumb {
  background: #ccc;
}
.vdatetime-year-picker__list::-webkit-scrollbar-track {
  background: #efefef;
}
.vdatetime-year-picker * {
  box-sizing: border-box;
}
.vdatetime-year-picker {
  box-sizing: border-box;
}
.vdatetime-year-picker::after {
  content: "";
  display: table;
  clear: both;
}
.vdatetime-year-picker__list {
  float: left;
  width: 100%;
  height: 305px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.vdatetime-year-picker__list::-webkit-scrollbar {
  width: 3px;
}
.vdatetime-year-picker__item {
  padding: 10px 0;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  transition: font-size 0.3s;
}
.vdatetime-year-picker__item:hover {
  font-size: 32px;
}
.vdatetime-year-picker__item--selected {
  color: #3f51b5;
  font-size: 32px;
}
.vdatetime-year-picker__item--disabled {
  opacity: 0.4;
  cursor: default;
}
.vdatetime-year-picker__item--disabled:hover {
  color: inherit;
  background: 0 0;
}
.vdatetime-month-picker__list::-webkit-scrollbar-thumb {
  background: #ccc;
}
.vdatetime-month-picker__list::-webkit-scrollbar-track {
  background: #efefef;
}
.vdatetime-month-picker * {
  box-sizing: border-box;
}
.vdatetime-month-picker {
  box-sizing: border-box;
}
.vdatetime-month-picker::after {
  content: "";
  display: table;
  clear: both;
}
.vdatetime-month-picker__list {
  float: left;
  width: 100%;
  height: 305px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.vdatetime-month-picker__list::-webkit-scrollbar {
  width: 3px;
}
.vdatetime-month-picker__item {
  padding: 10px 0;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  transition: font-size 0.3s;
}
.vdatetime-month-picker__item:hover {
  font-size: 32px;
}
.vdatetime-month-picker__item--selected {
  color: #3f51b5;
  font-size: 32px;
}
.vdatetime-month-picker__item--disabled {
  opacity: 0.4;
  cursor: default;
}
.vdatetime-month-picker__item--disabled:hover {
  color: inherit;
  background: 0 0;
}
</style>
